import {createBrowserHistory} from 'history';
import qs from 'query-string';

const history = createBrowserHistory();

history.location.query = qs.parse(history.location.search);
history.listen((location) => {
  location.query = qs.parse(location.search);
});

export default window.H = history;


// WEBPACK FOOTER //
// ./src/history.js